"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Header", {
    enumerable: true,
    get: function() {
        return Header;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _ri = require("react-icons/ri");
const _Theme = require("../../contexts/Theme");
const _Text = require("../Text/Text");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Header = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { label, direction, className = "", children, ...props } = param;
    const { colors } = (0, _Theme.useTheme)();
    const isInteractive = (0, _react.useMemo)(()=>{
        return direction != null && props.onClick != null;
    }, [
        direction,
        props.onClick
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("th", {
        ...props,
        ref: ref,
        className: _style.default.dynamic([
            [
                "61666d1ab94b0720",
                [
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.grayscale_5
                ]
            ]
        ]) + " " + ("".concat(className, " ").concat(isInteractive ? "interactive" : "").trim() || "")
    }, typeof label === "string" ? /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "label"
    }, label) : label, direction != null && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "61666d1ab94b0720",
                [
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.grayscale_5
                ]
            ]
        ]) + " " + "direction"
    }, direction === "asc" ? /*#__PURE__*/ _react.default.createElement(_ri.RiSortAsc, {
        size: 16
    }) : /*#__PURE__*/ _react.default.createElement(_ri.RiSortDesc, {
        size: 16
    }), " "), children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "61666d1ab94b0720",
        dynamic: [
            colors.grayscale[10],
            colors.grayscale[60],
            colors.grayscale_5
        ]
    }, "th.__jsx-style-dynamic-selector{-webkit-box-shadow:inset 0 -1px ".concat(colors.grayscale[10], ";-moz-box-shadow:inset 0 -1px ").concat(colors.grayscale[10], ";box-shadow:inset 0 -1px ").concat(colors.grayscale[10], ";background-color:#fff;color:").concat(colors.grayscale[60], ";text-align:left;padding:.5rem 1rem;line-height:1rem;z-index:1}th.__jsx-style-dynamic-selector:last-child{-webkit-border-radius:0 8px 0 0;-moz-border-radius:0 8px 0 0;border-radius:0 8px 0 0}th.__jsx-style-dynamic-selector:first-child{-webkit-border-radius:8px 0 0 0;-moz-border-radius:8px 0 0 0;border-radius:8px 0 0 0}th.interactive.__jsx-style-dynamic-selector{cursor:pointer}th.interactive.__jsx-style-dynamic-selector:hover{background-color:").concat(colors.grayscale_5, "}.direction.__jsx-style-dynamic-selector{display:inline;margin-left:.25rem}"))));
});
Header.displayName = "TableHeader";

//# sourceMappingURL=Header.js.map